import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import util from './common/util'
import './assets/styles/iconfont.css'
import './assets/styles/main.less'
import city from './assets/city.js'

// 插件
import plugins from '@/plugins';

Vue.use(ElementUI);
Vue.use(plugins);

// store
import store from '@/store/index';

// let baseURL = 'http://127.0.0.1/vmwarebt/lxgyl/lxgyl_back/public'
// let baseURL = 'https://jmmall.zxk.xm0592.com'
var baseURL = 'https://api.lx.xm0592.com'
// var baseURL = 'https://lxapi.work.xm0592.com'
Vue.config.productionTip = false
axios.defaults.baseURL = baseURL

axios.interceptors.request.use(config => {
    let token = localStorage.token
    if (token)
        config.headers['Access-Token'] = token
    return config
})
axios.interceptors.response.use(response => {
    if (response.data.code == 1) {
        return response.data
    } else {
        if (!response.data.msg) {
            response.data.msg = response.data.message ? response.data.message : '请求异常'
        }

        ElementUI.Message.error({
            message: response.data.msg
        });
    }
    return Promise.reject(response.data.msg);
}, error => {
    console.log(error)
    if (error.response.status == 400) {
        ElementUI.Message.error({
            message: error.response.data.msg
        });
    } else if (error.response.status == 401) {
        router.replace({path: '/'});
        // router.replace({path:'/Blurb/index.html'});
    } else if (error.response.status == 402) {
        localStorage.clear()
        router.replace({path: '/login.html'});
        // router.replace({path:'/Blurb/index.html'});

    } else {
        if (error.response.data && error.response.data.msg) {
            ElementUI.Message.error({
                message: error.response.data.msg
            });
        } else {
            ElementUI.Message.error({
                message: '请求异常'
            });
        }

    }
    return Promise.reject(error.response.data.msg);
})
Vue.prototype.axios = axios
Vue.prototype.app_url = baseURL

Vue.prototype.$check = util.formCheck
Vue.prototype.pageSizeNume = 1000
Vue.prototype.page = 1
// 地区
Vue.prototype.$city = city;

new Vue({
    render: h => h(App),
    store,
    router
}).$mount('#app')
